import * as React from "react";
import {
    PartnerLoginScreen,
    RenderFooter,
    RenderLoginSection, RenderTestimonials,
} from "login/utils";
import {useEffect, useState} from "react";
import {
    googleSignIn, hagridSignIn, setAccessTokenAuth,
    setApiVersion,
    setAuthParameters,
    setCurrentFlowChannel,
    setLoading,
    setPartnerLogin,
    setTwoFactorAuth,
} from "login/actions";
import {bindGapiObjectToButton, loadGoogleScript} from "login/gapiLogin";
import {IAuth, IMarketingTrackingParams, LoginChannel} from "StateInterface";
import {logEvent} from "analytics/googleAnalyics";
import {getJsonFromUrl, isNativeAndroid, isWebview} from "utils";
import {saveUtmParams} from "userform/actions";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {LoginMode, LoginStatus} from "login/reducer";
import {getAuthExternalStatus, setAuthentication} from "service";
import Loading from "components/loading";
import {initializeFacebookPixel} from "analytics/facebookAnalytics";
import {initializeQuoraPixel} from "analytics/quoraAnalytics";
import {RouteComponentProps} from "react-router-dom";
import {getAndroidLocalStorageValues} from "utils/android";
import Modal from "components/Modal";
import {partnerOfferings} from "./config";
import {gatewayUrl, googleClientId, googleLoginVersion, googleScript} from "config";
import {lsGetItem, lsSetItem, tokenUtility} from "utils/secure";
import axios from "axios";

interface IConnectProps {
    auth: IAuth;
    dispatch?: (action: any) => void;
    location: any;
    status: LoginStatus;
    loading: boolean;
    utm_source: string;
    utm_medium: string;
    utm_campaign: string;
    config: any;
    pathname: string;
    query: any;
    partnerName: string;
    isAndroid: boolean;
    currentEmployer: string;
    token: string;
    sourcingCode: string;
    leadId: string;
    isPartnerAndroid: boolean;
}

function Login(props: IConnectProps & RouteComponentProps) {
    const [authExternal, updateAuthExternal] = useState<boolean>(getAuthExternalStatus());
    const [componentWillMount, updateComponentWillMountStatus] = useState<boolean>(true);
    const [showModal, setShowModal] = useState<boolean>(false);
    const currentFlowChannel = window.location.href.split("/")[3] === "loan" ?
        LoginChannel.WEB_V3 : LoginChannel.WEB_V2;
    function onSignIn(googleUser, loginVersion?: "V2" | "V1") {
        const params: any = getJsonFromUrl();
        let marketingTrackingParams: IMarketingTrackingParams = null;
        if (params.gclid || params.fbclid) {
            marketingTrackingParams = {
                gclId: params.gclid,
                fbclId: params.fbclid,
            };
        }
        const utmSource = props.config.defaultSourcingCode ? props.config.defaultSourcingCode
            : props.utm_source || params.utm_source;
        const utmMedium = props.utm_medium || params.utm_medium;
        const utmCampaign = props.utm_campaign || params.utm_campaign;
        const sourcingCode = props.sourcingCode || params.sourcingCode || utmSource;
        if (utmSource || utmMedium || utmCampaign) {
            props.dispatch(saveUtmParams(utmSource, utmMedium, utmCampaign));
        }
        const utmParams = {
            source: utmSource,
            medium: utmMedium,
            campaign: utmCampaign,
        };
        if (loginVersion === "V2") {
            axios({
                method: "POST",
                url: `${gatewayUrl}/hagrid/signin/google`,
                data: {
                    loginChannel: currentFlowChannel,
                    marketingTrackingParams,
                    sourcingCode,
                    utmParams,
                    leadId: props.leadId,
                },
                headers: {
                  Authorization: `Bearer ${googleUser}`,
                },
              }).then((res) => {
                const {dsToken, ...user} = res.data;
                tokenUtility().storeToken(dsToken);
                lsSetItem("user", JSON.stringify(user));
                props.dispatch(hagridSignIn(user));
              });
        } else {
            props.dispatch(googleSignIn(
                marketingTrackingParams,
                currentFlowChannel,
                sourcingCode,
                utmParams,
                props.leadId,
                ),
            );
        }
    }

    const parseJwt = (token: string) => {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''));
      return JSON.parse(jsonPayload);
    }
    function resetLoading() {
        props.dispatch(setLoading(false));
    }
    function handleExtLogin(token, apiVersion) {
        if (apiVersion !== null && apiVersion !== undefined) {
            props.dispatch(setApiVersion({version: Number(props.query.apiVersion)}));
        }
        if (token != null) {
            setAuthentication(token);
            props.dispatch(googleSignIn(null, currentFlowChannel, null, null, null));
            props.history.push({pathname: props.location.pathname, query: props.query});
        }
    }
    const isAccessTokenLogin = () => {
        return !!((props.query["accessToken"] && props.query["userId"]) || (sessionStorage.getItem("accessToken") && sessionStorage.getItem("userId")));
    }
    function handleAndroidLogin() {
        let token = props.query.id_token;
        let apiVersion = props.query.apiVersion;
        const userData = getAndroidLocalStorageValues();
        if (!token) {
            token = userData.id_token;
        }
        if (!apiVersion) {
            apiVersion = userData.apiVersion;
        }
        if (token) {
            handleExtLogin(token, apiVersion);
        }
        if (apiVersion) {
            props.dispatch(setApiVersion({version: Number(apiVersion)}));
        }
    }
    const accessTokenLogin = () => {
        const redirect = sessionStorage.getItem("redirect") || JSON.parse(sessionStorage.getItem("initialQueryParams"))?.redirect;
        if (props.query["accessToken"] && props.query["userId"]) {
            const userId = decodeURI(props.query["userId"]).trim();
            sessionStorage.setItem("accessToken", props.query.accessToken);
            sessionStorage.setItem("userId", userId);
            if (props.query["utm_source"]) {
                sessionStorage.setItem("utm_source", props.query.utm_source);
            }
            setAuthentication(props.query.accessToken);
            props.dispatch(setAuthParameters({...props.query, accessToken: props.query.accessToken, userId}));
            if (localStorage.getItem("loginMode") === LoginMode.V2) {
                props.dispatch(setTwoFactorAuth({existing: true, userId}));
            } else {
                props.dispatch(setAccessTokenAuth({existing: true, userId}));
            }   
        } else if (sessionStorage.getItem("accessToken") && sessionStorage.getItem("userId")) {
            const sessionAccessToken = sessionStorage.getItem("accessToken");
            const sessionUserId = sessionStorage.getItem("userId");
            let utm_source = null;
            if (sessionStorage.getItem("initialQueryParams") || sessionStorage.getItem("utm_source")) {
                utm_source = JSON.parse(sessionStorage.getItem("initialQueryParams"))?.utm_source  || sessionStorage.getItem("utm_source");
            }
            props.dispatch(setAuthParameters({...props.query, accessToken: sessionAccessToken, userId: sessionUserId, ...(utm_source) && {utm_source}, ...(redirect) && {redirect}}));
            setAuthentication(sessionAccessToken);
            if (localStorage.getItem("loginMode") === LoginMode.V2) {
                props.dispatch(setTwoFactorAuth({existing: true, userId: props.query.userId || sessionUserId}));
            } else {
                props.dispatch(setAccessTokenAuth({existing: true, userId: props.query.userId || sessionUserId}));
            } 
        } else if (props.isPartnerAndroid || !props.isAndroid) {
            props.dispatch(setAuthParameters({...props.query, ...(redirect) && {redirect}}));
        }
    };
    function checkBeforeLogin() {
        accessTokenLogin();
        if (props.isAndroid && !props.isPartnerAndroid && !partnerOfferings.hasOwnProperty(props.query.currentEmployer)) {
            handleAndroidLogin();
            props.dispatch(setAuthParameters(props.query));
        }
        initializeFacebookPixel();
        initializeQuoraPixel();
    }
    function renderLogin() {
        return (
            <div className="container-fluid p-0">
                {showModal &&
                    <Modal
                        active = {showModal}
                        cancellable = {true}
                        cancelTitle = "Close"
                        onClose={() =>  setShowModal(false)}
                    >
                        <div className="partner-modal-container">
                            <p className="partner-heading">
                            Dear {partnerOfferings.hasOwnProperty(props.query.utm_source) ? partnerOfferings[props.query.utm_source]['companyName'] : ''} Merchants,
                            </p>
                            <p>
                                {partnerOfferings[props.query.utm_source].message}
                            </p>
                        </div>
                    </Modal>
                }
                <Loading active={props.loading}/>
                <RenderLoginSection partner={props.utm_source}/>
                <RenderTestimonials/>
                <RenderFooter/>
            </div>
        );
    }
    useEffect(() => {
        window.scrollTo(0, 0);
        const btnNames = ["google-sign-in"];
        if (props.pathname !== "sl") {
            btnNames.push("btn-login-existing-user");
        }
        if (props.token) {
          const loginDetails = parseJwt(props.token);
          loginDetails.user_id && props.dispatch(setPartnerLogin({userId: loginDetails.user_id, roles: loginDetails.roles}));
          setAuthentication(props.token);
        }
        if (!isAccessTokenLogin() && !isWebview())  {
            if (googleLoginVersion === "V2") {
                loadGoogleScript(googleScript, () => {
                    (window as any).google.accounts.id.initialize({
                        client_id: googleClientId,
                        itp_support: true,
                        callback: (cred: { credential: string; select_by: string }) => {
                            onSignIn(cred.credential, googleLoginVersion);
                        },
                    });

                    if (tokenUtility().getStoredToken() && lsGetItem("user")) {
                        props.dispatch(hagridSignIn(JSON.parse(lsGetItem("user"))));
                    } else {
                        (window as any).google.accounts.id.renderButton(
                            document.getElementById(btnNames[0]),
                            {size: "large", theme: "filled_blue", width: 300},
                        );
                        resetLoading();
                    }
                });
            } else {
                bindGapiObjectToButton(btnNames, onSignIn, resetLoading);
            }
        }
        if (partnerOfferings.hasOwnProperty(props.query.utm_source) && partnerOfferings[props.query.utm_source].message) {
          setShowModal(true);
          resetLoading();
        }
        props.dispatch(setCurrentFlowChannel(currentFlowChannel));
        updateAuthExternal(getAuthExternalStatus());
        updateComponentWillMountStatus(false);
        return () => {
            resetLoading();
        };
    }, []);
    if (componentWillMount) {
        checkBeforeLogin();
    }
    if (props.isAndroid && !partnerOfferings.hasOwnProperty(props.query.currentEmployer)) {
      props.dispatch(setLoading(true));
    }
    if (authExternal) {
        setLoading(true);
    }
    return authExternal ? <Loading active={props.loading}/> :
        props.pathname === "sl" ? renderLogin() : <PartnerLoginScreen config={props.config}/>;
}
const mapStateToProps = (state: IReduxState): IConnectProps => {
    const auth = state.login.auth ? state.login.auth : null;
    const query = state.router.location.query ? state.router.location.query : null;
    const config = state.userform.config;
    return {
        auth,
        location: state.router.location,
        status: state.login.status,
        loading: state.login.loading,
        utm_source: query ? query.utm_source : null,
        utm_medium: query ? query.utm_medium : null,
        utm_campaign: query ? query.utm_campaign : null,
        sourcingCode: query ? query.sourcingCode : null,
        leadId: query ? query.leadId : null,
        token: query ? query.token : null,
        config,
        pathname: state.userform.param,
        query,
        partnerName: state.userform.param,
        isAndroid: state.login.isAndroid,
        currentEmployer: state.login.authExt ? state.login.authExt.currentEmployer : null,
        isPartnerAndroid: state.login.isPartnerAndroid,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(Login);
